(function ($) {
	const $expandables = $('.dias-event__content');
	const collapsedClass = 'dias-event__content-wrap--collapsed';

	if (!$expandables.length) {
		return;
	}

	$expandables.each(setupExpandable);

	function setupExpandable() {
		const $item = $(this);
		const $wrap = $item.closest('.dias-event__content-wrap');

		if ($item.height() < 100) {
			return;
		}

		const $button = $('<button class="dias-event__expand-toggle">Read more</button>');

		$wrap.addClass(collapsedClass);
		$wrap.append($button);

		$button.on('click', toggleExpand);

		function toggleExpand() {
			$wrap.addClass('dias-event__content-wrap--animating');
			$wrap.toggleClass(collapsedClass);

			if ($wrap.hasClass(collapsedClass)) {
				$item.animate({ scrollTop: 0 }, 1);
				$button.text('Read more');
			} else {
				$button.text('Read less');
			}

			setTimeout(() => {
				$wrap.removeClass('dias-event__content-wrap--animating');
			}, 500);
		}
	}
})(jQuery);
